import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import classname from 'classnames';
import { clearApiError } from './actions/application';
import { fetchTerritories } from './actions/territories';
import { fetchCoordinations } from './actions/coordinations';
import { fetchUsers } from './actions/users';
import { getUser, logout } from './actions/session';
import Navbar from './components/containers/Navbar';
import {Link} from 'react-router';
import Sidebar from 'react-sidebar';
import Sidemenu from './components/presentation/Sidemenu';
import {Modal, ModalBody, Button} from 'reactstrap';

function mapStateToProps(state) {
    return {
        application : state.application,
        session : state.session
    };
}


class App extends Component {

    constructor(props) {
        super(props);
        this.getBreadcrumbs = this.getBreadcrumbs.bind(this);
        this.toggleSidemenu = this.toggleSidemenu.bind(this);
        this.resetSession = this._resetSession.bind(this);
        this.state = {
            showSidebar : false
        };
    }

    componentWillMount() {
        const token = sessionStorage.getItem('api_token');
        const user = this.props.session.user;
        if(token && ! user) {
            this.props.dispatch(getUser(token));
        }
        if(user && token) {
            this.props.dispatch(fetchTerritories());
            this.props.dispatch(fetchCoordinations());
            this.props.dispatch(fetchUsers());
        }
    }

    _resetSession() {
        this.props.dispatch(logout());
        this.props.dispatch(clearApiError());
        this.props.router.push('/login');
    }

    toggleSidemenu() {
        this.setState((prevState) => {
            return {
                showSidebar : ! prevState.showSidebar
            }
        });
    }

    getBreadcrumbs() {
        if( ! this.props.route) return [];
        const routes = this.props.routes;
        let items = [];
        for(let i=0; i< routes.length; i++) {
            const route = routes[i];
            if(route.name) {
                let path = route.path;
                if(path.startsWith(':')) {
                    const pathVar = path.substring(1);
                    const value = this.props.params[pathVar];
                    path = value;
                }
                if(path.endsWith('/')) {
                    path = path.substring(0, path.length-1);
                }
                const previous = items.length > 0 ? items[items.length-1].path : '';
                items.push({
                    name : route.name,
                    path : previous + path + "/",
                });

            }
        }
        console.log(items);
        return items;
    }

    render() {
        const breadcrumbs = this.getBreadcrumbs();
        const sidemenuProps = {...this.props, toggleSidemenu : this.toggleSidemenu, dispatch : this.props.dispatch }
        const message = this.props.application.message;
        const error = this.props.application.error;
        return (
            <Sidebar sidebar={Sidemenu(sidemenuProps)} open={this.state.showSidebar} onSetOpen={this.toggleSidemenu} sidebarClassName="sidebar">
                <Navbar session={this.props.session} toggleSidemenu={this.toggleSidemenu} />
                {
                    message ?
                    (
                        <div className={classname('alert', 'alert-' + message.type)}>
                            {message.content}
                        </div>
                    ) : null
                }
                <ol className="breadcrumb" hidden={breadcrumbs.length <= 1}>
                    {
                        breadcrumbs.map((elem, i) => {
                            const active = i === breadcrumbs.length -1;
                            return (
                                <li className={classname('breadcrumb-item', {active})} key={i}>
                                    {
                                        active ?
                                            elem.name
                                        :
                                            <Link to={elem.path}>{elem.name}</Link>
                                    }
                                </li>
                            );
                        })
                    }    
                </ol>
                
                
                { this.props.children }

                <Modal isOpen={error !== null} toggle={() => this.props.dispatch(clearApiError())} backdrop="static">
                    {
                        ! error ? null :
                            <ModalBody>
                                {
                                    error.status === 403 || error.status === 401 ?
                                    'Tu sesión expiró. Por favor, vuelve a iniciar sesión'
                                    :
                                    (
                                        error.response ? error.response : 'Ocurrió un error en el servidor. Intenta actualizar esta página.'
                                    )
                                }
                                <div className="text-right">
                                    {
                                        error.status === 403 || error.status === 401 ?
                                            <Button color="primary" onClick={this.resetSession}>Inicio de sesión</Button>
                                        : null
                                    }
                                </div>
                            </ModalBody>
                    }
                    
                </Modal>
            </Sidebar>
        );
    }
}

export default connect(mapStateToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/App.jsx
 **/